import { grpc } from "@improbable-eng/grpc-web";
import { CRCardsReply, CRCardsRequest } from "./cardreader_pb";
import { CardReaderClient, CardReader } from "./cardreader_pb_service";

const REACT_APP_CARDREADER_API = process.env.REACT_APP_CARDREADER_API !== undefined ? process.env.REACT_APP_CARDREADER_API : "";

export const requestCards = (customer: string) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];

  const client = new CardReaderClient(REACT_APP_CARDREADER_API); // ,null,null
  const req = new CRCardsRequest();
  req.setCustomer(customer);

  console.log("request:");
  console.log(req.toObject());

  const metadata = new grpc.Metadata({
    'Authorization': `Bearer ${token}`,
  });

  client.requestCards(req, metadata, (error, resp) => {
    console.log("cards request reply:");
    console.log(resp?.getCardInfoList());
  });
}

export const createStatusStream = (customer : string, onMessage : ((msg : CRCardsReply) => void), onError : (() => void)) => {
  console.log("creating status stream");
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const req = new CRCardsRequest();
  req.setCustomer(customer);
  const metadata = new grpc.Metadata({
    'Authorization': `Bearer ${token}`,
  });
  return grpc.invoke(CardReader.CardsStatus, {
    request: req,
    host: REACT_APP_CARDREADER_API,
    metadata,
    onMessage: (message: CRCardsReply) => {
      console.log("got cards: ", message.toObject());
      onMessage(message);
    },
    onEnd: (code: grpc.Code, msg: string | undefined, trailers: grpc.Metadata) => {
      if (code === grpc.Code.OK) {
        console.log("all ok")
      } else {
        console.log("hit an error", code, msg, trailers);
        onError();
      }
    }
  });
};